import i18next from 'i18next';

import { downloadDatasheet } from 'common/api/sunpal/datasheets';
import { downloadFile, showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    DOWNLOAD_DATASHEET,
    DOWNLOAD_DATASHEET_FAILURE,
    DOWNLOAD_DATASHEET_SUCCESS,
} from '../actionTypes';
import { interactiveProposalPreviewActions } from '../reducer';

export default (datasheetName, openLoading, closeLoading) => (dispatch) => {
    if (!datasheetName) {
        showToast({
            body: i18next.t('The file url is corrupted'),
            type: 'danger',
        });
        return false;
    }

    dispatch(interactiveProposalPreviewActions[DOWNLOAD_DATASHEET]());

    openLoading(i18next.t('Downloading'));

    downloadDatasheet(datasheetName)
        .then((response) => {
            dispatch(
                interactiveProposalPreviewActions[DOWNLOAD_DATASHEET_SUCCESS](),
            );
            const url = window.URL.createObjectURL(response.data);

            downloadFile(url, datasheetName);

            window.URL.revokeObjectURL(url);

            closeLoading();
            showToast({
                body: i18next.t('It has been downloaded successfully'),
            });
        })
        .catch((error) => {
            dispatch(
                interactiveProposalPreviewActions[DOWNLOAD_DATASHEET_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            closeLoading();
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
